import { Store } from 'Services/Store'

export enum SharedService {
  Store = 'store',
}

const SERVICES: Record<string, any> = {}

function getService<T = any>(service: SharedService): T {
  const instance = SERVICES[service]
  if (!instance) throw new Error(`${service} not found in Shared`)
  return instance as T
}

// Store
function setStore(store: Store) {
  SERVICES[SharedService.Store] = store
}
function getStore() {
  return getService<Store>(SharedService.Store)
}
const Shared = { setStore, getStore }

export default Shared
